export * from './apikeys.service';
import { ApikeysService } from './apikeys.service';
export * from './contentVerifications.service';
import { ContentVerificationsService } from './contentVerifications.service';
export const APIS = [ApikeysService, ContentVerificationsService];
